import { render } from "./VectorStoreFileUploader.vue?vue&type=template&id=92ceb3d2"
import script from "./VectorStoreFileUploader.vue?vue&type=script&lang=js"
export * from "./VectorStoreFileUploader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__